import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeAchievedComponent } from './badge-achieved.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { BadgeListItemModule } from '../badge-list-item/badge-list-item.module';
import { BadgeOverviewListModule } from '../badge-overview-list/badge-overview-list.module';

@NgModule({
  declarations: [BadgeAchievedComponent],
  imports: [CommonModule, FGBSharedModule, BadgeListItemModule, BadgeOverviewListModule],
  exports: [BadgeAchievedComponent],
})
export class BadgeAchievedModule {}
